import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Contact from '../sections/Contact';
import usePageMeta from '../hooks/usePageMeta';
import useLangPrefix from '../hooks/useLangPrefix';

function ContactPage() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();

  usePageMeta({
    title: `${t('contact.heading')} | Marwa Hawshar`,
    description: t('contact.subheading'),
    path: `${langPrefix}/contact`,
  });

  return (
    <>
      <h1 className="visually-hidden">{t('contact.heading')}</h1>
      <Contact />
      <section className="py-5 py-lg-6 bg-light border-top">
        <div className="container">
          <div className="row g-4 g-lg-5 justify-content-center">
            <div className="col-lg-5">
              <h2 className="h5 fw-semibold text-navy mb-4">{t('contact.hoursHeading')}</h2>
              <dl className="mb-0 small">
                <dt className="text-muted fw-normal mb-1">{t('contact.hours.mondayThursdayLabel')}</dt>
                <dd className="mb-3 text-navy">{t('contact.hours.mondayThursdayValue')}</dd>
                <dt className="text-muted fw-normal mb-1">{t('contact.hours.fridaySaturdayLabel')}</dt>
                <dd className="mb-3 text-navy">{t('contact.hours.fridaySaturdayValue')}</dd>
                <dt className="text-muted fw-normal mb-1">{t('contact.hours.sundayLabel')}</dt>
                <dd className="mb-0 text-navy">{t('contact.hours.sundayValue')}</dd>
              </dl>
            </div>
            <div className="col-lg-7">
              <h2 className="h5 fw-semibold text-navy mb-4">{t('contact.consultationHeading')}</h2>
              <p className="text-muted mb-3">{t('contact.consultationInfo')}</p>
              <Link to={`${langPrefix}/blog/lawyer-tripoli-lebanon`} className="link-navy text-decoration-none small">
                {t('contact.consultationLinkText')}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactPage;
